import '../css/public/base';
import 'load-awesome/css/ball-spin-clockwise';

import { Turbo } from "@hotwired/turbo-rails"
Turbo.session.drive = false

import '../lib/turbolinks/form-submission';
